import { render, staticRenderFns } from "./ClassSection.vue?vue&type=template&id=22dd49bd&scoped=true"
import script from "./ClassSection.vue?vue&type=script&lang=js"
export * from "./ClassSection.vue?vue&type=script&lang=js"
import style0 from "./ClassSection.vue?vue&type=style&index=0&id=22dd49bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd49bd",
  null
  
)

export default component.exports